export default function () {
    return {
        chartData: []
    }
}